import loadable from '@loadable/component'

export default [
  {
    path: '/game/LuckyBigWheel',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-LuckyBigWheel" */ '~/pages/game/LuckyBigWheel'
        )
    ),
  },
]
